export enum DefaultView {
  OPEN = "open",
  ASSIGNED = "assigned",
  SENT = "sent",
  DRAFTS = "drafts",
  SPAM = "spam",
  ARCHIVED = "archived",
}

export const DEFAULT_VIEW_IDS: ReadonlySet<string> = new Set(
  Object.values(DefaultView),
);

export function isDefaultView(value: string): value is DefaultView {
  return DEFAULT_VIEW_IDS.has(value);
}
